module.exports = __webpack_public_path__ + "img/environment.01fcbea4.png";